import { Controller } from '@hotwired/stimulus'

// I-OUX-5: the bar of a list's checked rows, on the form the row checkboxes belong to (form="<id>", name ids[]), so the
// browser submits them without JS. The bar shows only with a selection; „vybrat vše“ in the head ([data-select-all-for])
// checks every row; Shift+click checks the range from the last clicked row (4 days = 2 clicks, T3b).
export default class RowSelectController extends Controller<HTMLFormElement> {
  static override targets = ['count']
  static override values = { count: String }
  declare readonly countTarget: HTMLElement
  declare readonly countValue: string
  private last: HTMLInputElement | null = null

  private readonly click = (event: MouseEvent): void => {
    const box = event.target
    if (!(box instanceof HTMLInputElement) || box.type !== 'checkbox') return
    if (box.dataset['selectAllFor'] === this.element.id) {
      for (const row of this.boxes()) row.checked = box.checked
    } else if (box.getAttribute('form') === this.element.id) {
      const boxes = this.boxes()
      if (event.shiftKey && this.last && boxes.includes(this.last)) {
        const [a, b] = [boxes.indexOf(this.last), boxes.indexOf(box)]
        for (const row of boxes.slice(Math.min(a, b), Math.max(a, b) + 1)) row.checked = box.checked
      }
      this.last = box
    } else return
    this.update()
  }

  override connect(): void {
    document.addEventListener('click', this.click)
    this.update()
  }

  override disconnect(): void {
    document.removeEventListener('click', this.click)
  }

  clear(): void {
    for (const row of this.boxes()) row.checked = false
    this.update()
  }

  private boxes(): HTMLInputElement[] {
    return Array.from(document.querySelectorAll<HTMLInputElement>(`input[type=checkbox][form="${this.element.id}"]`))
  }

  private update(): void {
    const boxes = this.boxes()
    const checked = boxes.filter((row) => row.checked).length
    this.element.hidden = checked === 0
    this.countTarget.textContent = this.countValue.replace('%{count}', String(checked))
    const all = document.querySelector<HTMLInputElement>(`[data-select-all-for="${this.element.id}"]`)
    if (all) {
      all.checked = checked > 0 && checked === boxes.length
      all.indeterminate = checked > 0 && checked < boxes.length
    }
  }
}
